import sanityClient from '@sanity/client';
import imageUrlBuilder from '@sanity/image-url';

export const client = sanityClient({
    projectId: process.env.REACT_APP_SANITY_PROJECT_ID,
    dataset: 'production',
    apiVersion: '2022-11-06',
    useCdn: true,
    token: process.env.REACT_APP_SANITY_TOKEN,
});

const builder = imageUrlBuilder(client);

export const urlFor = (source) => builder.image(source);

export const likePost = (pinId) => { client.patch(`pins/${pinId}`).inc({ likes: 1 }).commit(); }
export const unlikePost = (pinId) => { client.patch(`pins/${pinId}`).dec({ likes: 1 }).commit(); }
